<template>
  <div>
    <b-modal
      id="modalHistoricoUsuario"
      ref="modalHistoricoUsuario"
      size="xl"
      button-size="sm"
      no-close-on-backdrop
      no-stacking
      ok-only
      ok-title="Ok"
      :cancel-disabled="true"
      cancel-variant="false"
      scrollable
    >
      <div slot="modal-title">
        <h5>Histórico de Alterações - USUÁRIOS</h5>
        <fieldset class="font-weight-bold text-muted">
          Histórico de alterações dos usuários
        </fieldset>
      </div>

      <b-row>
        <b-col>
          <b-table
            ref="tabelaHistorico"
            :items="historicoProvider"
            :fields="colunas"
            :current-page="currentPage"
            :per-page="perPage"
            responsive
            hover
            show-empty
            empty-text="Nenhum registro de alteração encontrado"
            class="text-nowrap"
          >
            <template #head(nomeRegistro)="data">
              <div style="min-width: 250px;">
                {{ data.label }}
              </div>
            </template>

            <template #head(alteradoEm)="data">
              <div style="min-width: 170px;">
                {{ data.label }}
              </div>
            </template>

            <template #cell(alteradoEm)="{ value }">
              {{ formatarData(value) }}
            </template>

            <template #cell(nomeRegistro)="{ value }">
              {{ value || '-' }}
            </template>

            <template #cell(alteradoPor)="{ value }">
              {{ value || '-' }}
            </template>

            <template #cell(campo)="{ item }">
              <b-badge variant="light-success">
                {{ formatarCampo(item.campo) }}
              </b-badge>
            </template>

            <template #cell(valorAntigo)="{ value }">
              {{ formatarValor(value) }}
            </template>

            <template #cell(valorNovo)="{ value }">
              {{ formatarValor(value) }}
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row
        v-if="totalRows > 0"
        class="mt-1 mb-1"
      >
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
      <loading :is-loading="isLoading" />
    </b-modal>
  </div>
</template>

<script>
import api from '@/app/usuario/shared/services/api'
import Loading from '@pilar/components/loading/Loading.vue'

const mapeamentoCampos = {
  nome: 'Nome',
  cpf: 'CPF',
  login: 'Login',
  email: 'Login (E-mail)',
  ativo: 'Ativo',
  inativar: 'Inativar',
  reativar: 'Reativar',
  criar: 'Criação',
  remover: 'Exclusão',
  administrador: 'Administrador',
  contador: 'Contador',
  crc: 'CRC',
  senha: 'Senha',
  permissoes: 'Permissões',
  empresas: 'Empresas vinculadas',
}

export default {
  name: 'ModalHistoricoUsuario',
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      idsAtual: [],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      colunas: [
        { key: 'alteradoEm', label: 'Data' },
        { key: 'nomeRegistro', label: 'Login (E-mail)' },
        { key: 'alteradoPor', label: 'Alterado por' },
        { key: 'campo', label: 'Campo' },
        { key: 'valorAntigo', label: 'De' },
        { key: 'valorNovo', label: 'Para' },
      ],
    }
  },
  methods: {
    show(ids) {
      this.idsAtual = ids || []
      this.currentPage = 1
      this.$refs.modalHistoricoUsuario.show()
      if (this.$refs.tabelaHistorico) {
        this.$refs.tabelaHistorico.refresh()
      }
    },
    historicoProvider(ctx) {
      this.isLoading = true
      return api.getHistoricoPaged(this.idsAtual, ctx.currentPage, ctx.perPage)
        .then(response => {
          const payload = response.data || response
          this.totalRows = payload.total || 0
          return payload.valores || []
        })
        .catch(() => {
          this.totalRows = 0
          return []
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    formatarData(dataString) {
      if (!dataString) return ''
      try {
        const data = new Date(dataString)
        const dia = String(data.getDate()).padStart(2, '0')
        const mes = String(data.getMonth() + 1).padStart(2, '0')
        const ano = data.getFullYear()
        const hora = String(data.getHours()).padStart(2, '0')
        const minuto = String(data.getMinutes()).padStart(2, '0')
        return `${dia}/${mes}/${ano} ${hora}:${minuto}`
      } catch {
        return dataString
      }
    },
    formatarCampo(campo) {
      if (!campo) return ''
      const lower = campo.toLowerCase()
      return mapeamentoCampos[lower] || campo
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return 'Em branco'
      if (valor === true || valor === 'True' || valor === 'true' || valor === 'Sim') return 'Ativo'
      if (valor === false || valor === 'False' || valor === 'false' || valor === 'Não') return 'Inativo'
      if (typeof valor === 'string' && valor.length > 0) {
        return valor.charAt(0).toUpperCase() + valor.slice(1)
      }
      return valor
    },
  },
}
</script>
